import React from 'react';
import Stack from '@mui/material/Stack';
import {ContentBlockHeader} from '@growcloud-io/dc/components/surface/ContentBlockHeader';
import {newColumnStack} from "@growcloud-io/gcio-commons/common/utils/UiUtils";


export const FaqPage = ({}) => {
  return (
    <Stack direction={'column'} sx={newColumnStack()}>
      <ContentBlockHeader
        PageTitle={'FAQ'}
        SubHeader={''}
        Alignment="left"
      />
    </Stack>
  );
}